import { cn } from "@/lib/utils";

interface ThinkingIndicatorProps {
  className?: string;
}

export function ThinkingIndicator({ className }: ThinkingIndicatorProps) {
  return (
    <div className={cn("group flex justify-start", className)}>
      <div className="flex flex-col gap-1">
        <div className="rounded-lg p-3 w-fit bg-muted/50">
          <div className="flex items-center gap-2">
            <div className="flex gap-1">
              <span
                className="w-2 h-2 bg-foreground/40 rounded-full animate-pulse"
                style={{ animationDelay: "0ms" }}
              />
              <span
                className="w-2 h-2 bg-foreground/40 rounded-full animate-pulse"
                style={{ animationDelay: "150ms" }}
              />
              <span
                className="w-2 h-2 bg-foreground/40 rounded-full animate-pulse"
                style={{ animationDelay: "300ms" }}
              />
            </div>
            <span className="text-sm text-muted-foreground">Model is thinking...</span>
          </div>
        </div>
      </div>
    </div>
  );
}

